import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isResourceType } from '@backstage/plugin-catalog';

/**
 * L'onglet « Sauvegardes » des ressources `resource:database`. Un plugin à
 * part de `@platform/plugin-database` (phase 4b, tâche 7), comme le tri
 * l'a décidé — il dépend de `DatabaseShell` exporté par ce dernier pour
 * garder la même barre de contexte (sélecteur d'environnement, identifiant
 * de connexion, statut, Reconfigurer) que l'onglet « Base de données ».
 */
const isDatabase = isResourceType('database');

const backupsContent = EntityContentBlueprint.make({
  name: 'backups',
  params: {
    path: '/backups',
    title: 'Sauvegardes',
    filter: isDatabase,
    loader: () => import('./BackupsPage').then(m => <m.BackupsPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'db-backup',
  extensions: [backupsContent],
});
